import React from 'react';
import Header from './components/header/Header';
import Articles from './components/articles/Articles';
import Urios from './components/Urios/Urios';
import Footer from './components/footer/Footer';

function App() {
  return (
    <div>
      <Header />
      <Urios />
      <Articles />
      <Footer />
    </div>
  );
}

export default App;
